import pollQuestionController from './pollQuestionController'
export default pollQuestionController



// WEBPACK FOOTER //
// ../src/controllers/pollQuestionController/index.js